import React from 'react';
import { Box, Tabs, Tab, useTheme } from '@mui/material';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import { ImpactTabType } from '../../hooks/useImpactStats';

interface ImpactTabsProps {
    selectedTab: ImpactTabType;
    setSelectedTab: (tab: ImpactTabType) => void;
}

const ImpactTabs: React.FC<ImpactTabsProps> = ({ selectedTab, setSelectedTab }) => {
    const theme = useTheme();

    const handleChange = (_event: React.SyntheticEvent, newValue: ImpactTabType) => {
        setSelectedTab(newValue);
    };

    return (
        <Box
            sx={{
                backgroundColor: 'rgba(22, 28, 36, 0.7)',
                backdropFilter: 'blur(8px)',
                borderRadius: '10px 10px 0 0',
                pointerEvents: 'auto',
                overflow: 'hidden'
            }}
        >
            <Tabs
                value={selectedTab}
                onChange={handleChange}
                aria-label="impact statistics tabs"
                variant="fullWidth"
                sx={{
                    minHeight: '48px',
                    '& .MuiTab-root': {
                        minHeight: '48px',
                        fontSize: '0.875rem',
                        fontWeight: 600,
                        textTransform: 'none',
                        color: 'text.secondary',
                        '&.Mui-selected': {
                            color: 'white',
                        },
                    },
                    '& .MuiTabs-indicator': {
                        height: 3,
                    },
                }}
            >
                <Tab
                    value="energy"
                    label="Energy Impact"
                    icon={<ElectricBoltIcon />}
                    iconPosition="start"
                    sx={{
                        color: selectedTab === 'energy' ? theme.palette.warning.main : 'text.secondary',
                        '&.Mui-selected': {
                            color: theme.palette.warning.main,
                        }
                    }}
                />
                <Tab
                    value="water"
                    label="Water Impact"
                    icon={<WaterDropIcon />}
                    iconPosition="start"
                    sx={{
                        color: selectedTab === 'water' ? theme.palette.info.main : 'text.secondary',
                        '&.Mui-selected': {
                            color: theme.palette.info.main,
                        }
                    }}
                />
                <Tab
                    value="land"
                    label="Land Impact"
                    icon={<LocalFloristIcon />}
                    iconPosition="start"
                    sx={{
                        color: selectedTab === 'land' ? theme.palette.success.main : 'text.secondary',
                        '&.Mui-selected': {
                            color: theme.palette.success.main,
                        }
                    }}
                />
            </Tabs>
        </Box>
    );
};

export default ImpactTabs; 